<ng-container [ngSwitch]="mode">
  <ng-container *ngSwitchCase="LabelMode.DEFAULT" [ngTemplateOutlet]="default"></ng-container>
  <ng-container *ngSwitchCase="LabelMode.INLINE" [ngTemplateOutlet]="inline"></ng-container>
  <ng-container *ngSwitchCase="LabelMode.NO_LABEL" [ngTemplateOutlet]="input"></ng-container>
</ng-container>

<ng-template #input>
  <div class="demo-inline-spacing" [ngClass]="inputClass">
    <ng-container *ngFor="let option of options; let i = index">
      <div class="custom-radio-wrapper">
        <div class="form-check form-check-custom form-check-sm">
          <input type="radio" [id]="name + i" [name]="name" [value]="option.id" class="form-check-input" [formControl]="form" />
          <label class="custom-control-label fs-form-control ms-2" [for]="name + i">{{ option.name }}</label>
        </div>
      </div>
    </ng-container>
    <p class="text-muted m-0" *ngIf="options?.length === 0">
      - {{ "APP.NO_DATA" | translate }} -
    </p>
  </div>
</ng-template>

<ng-template #mainLabel>
  <ng-container *ngIf="labelValue">
    <label [for]="name" class="col-form-label fw-bold fs-6 py-2" [ngClass]="required ? 'required' : ''">{{ label | translate : { value: labelValue } }}</label>
  </ng-container>
  <ng-container *ngIf="!labelValue">
    <label [for]="name" class="col-form-label fw-bold fs-6 py-2" [ngClass]="required ? 'required' : ''">{{ label | translate }}</label>
  </ng-container>
</ng-template>

<ng-template #default>
  <div class="form-group" [ngClass]="classes">
    <ng-container [ngTemplateOutlet]="mainLabel"></ng-container>
    <ng-container [ngTemplateOutlet]="input"></ng-container>
  </div>
</ng-template>

<ng-template #inline>
  <div class="form-group form-group-inline">
    <ng-container [ngTemplateOutlet]="mainLabel"></ng-container>

    <ng-container [ngTemplateOutlet]="input"></ng-container>
  </div>
</ng-template>